<template>
  <div id="setting-tab">
    <b-form>
      <b-tabs class="setting-tab">
        <b-tab :title="'กำหนดคะแนน'" :title-link-class="['font-medium-5']" lazy>
          <setting-point
            :scoreData="scoreData"
            @onUpdateScore="onUpdateScore"
          />
        </b-tab>
        <b-tab :title="'ผลลัพธ์'" :title-link-class="['font-medium-5']" lazy>
          <result
            :scoreData="scoreData"
            :maxValueBefore="maxValueBefore"
            @onUpdateMinScore="onUpdateMinScore"
            @onUpdateMaxScore="onUpdateMaxScore"
            @onUploadBanner="onUploadBanner"
            @addResult="addResult"
            @onRemoveSetResult="onRemoveSetResult"
            @onSetMaxScore="onSetMaxScore"
          />
        </b-tab>
      </b-tabs>
    </b-form>
  </div>
</template>

<script>
import Result from "./ScoreTab/Result.vue";
import SettingPoint from "./ScoreTab/SettingScore.vue";
import useScoreTab from "../hooks/useScoreTab";

export default {
  props: {
    isEdit: { type: Boolean, default: false },
  },
  components: { SettingPoint, Result },
  setup(props) {
    const {
      scoreData,
      onUpdateScore,
      onUpdateMinScore,
      onUpdateMaxScore,
      onUploadBanner,
      addResult,
      maxValueBefore,
      minValueBefore,
      isMax,
      onRemoveSetResult,
      onSetMaxScore,
    } = useScoreTab(props);

    return {
      scoreData,
      onUpdateScore,
      onUpdateMinScore,
      onUpdateMaxScore,
      onUploadBanner,
      addResult,
      maxValueBefore,
      minValueBefore,
      isMax,
      onRemoveSetResult,
      onUpdateMaxScore,
      onSetMaxScore,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/survey/score.css";
</style>
